import Utils from "./utils";
import $ from 'jquery';

class VideoPopin {

	/**
	 * @param options
	 */
	constructor() {

		Utils.debug('VIDEOPOPIN :: construct');

		if($('.videoPopin').length === 0) {
			$('#app').append('<div class="videoPopin">' +
				'<div class="videoPopin__overlay"></div>' +
				'<div class="videoPopin__content">' +
				'<video src="" controls></video>' +
				'</div>' +
				'<div class="videoPopin__close customCursor" data-cursor="glass">' +
				'<span></span>' +
				'<span></span>' +
				'</div>' +
				'</div>')
		}

		this.$video = $('.videoPopin');

		var self = this;
		$('#app').on('click','.btnVideoPlayer',function () {
			self.openVideo($(this).attr('urlVideo'));
		})

		$('#app').on('click','.videoPopin__close', function () {
			self.closeVideo();
		})


	}

	openVideo(videoPath){
		Utils.debug('openVideo : ' + videoPath);

		let video = this.$video.find('video');

		$(video).attr('src', videoPath);
		//console.log($(video));
		gsap.to(this.$video, 1, {xPercent: -100, ease: 'Expo.easeInOut'});
		gsap.fromTo('.videoPopin__overlay', 1, {skewX: 2, xPercent: 5}, {skewX: 0, xPercent: -100, ease: 'Expo.easeInOut', delay: 0.5});
		$(video).get(0).play();


	}

	closeVideo(){
		let video = this.$video.find('video');
		$(video).get(0).pause();
		gsap.fromTo('.videoPopin__overlay', 1, {skewX: 2}, {skewX: 0, xPercent: 0, ease: 'Expo.easeInOut'});
		gsap.to(this.$video, 1, {xPercent: 0, ease: 'Expo.easeInOut', delay: 0.5});
	}





}

module.exports = VideoPopin;
